/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'custodial-minor-info',
  template: require('./custodial-minor-info.component.html')
})

export class CustodialMinorInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('custodial-minor-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    const lastStep = this.form.stepsComplete[this.form.stepsComplete.length - 1];
    this.form.buttons.inputs.back.path = `/${lastStep.route}`;
  }

  updateOptionValue(event) { }

  updateBtnClicked(e) {
    this.handleClick(e.action);
  }
}
